export default __webpack_public_path__ + "static/img06-ada3e4794be49550776d2c35fcf2d2e5.webp";